import produce from 'immer';
import { createActions, handleActions } from 'redux-actions';

import { Category } from 'typing/models';
import {
  AbstractPayload, BaseState, CategoriesState,
} from 'typing/store';

import { LIST_FEATURED_CATEGORIES } from 'utils/fetchs';

import { fetchStateGenerator } from './checkFetchReducerCreator';

export const {
  listFeaturedCategoriesRequest,
  listFeaturedCategoriesSuccess,
  listFeaturedCategoriesFailure,
  listFeaturedCategoriesClean,
} = createActions(
  {},
  ...fetchStateGenerator(LIST_FEATURED_CATEGORIES),
  { prefix: 'FEATURED_CATEGORIES' },
);

const INITIAL_STATE = {
  list: {
    data: [],
  },
  detail: null,
};

export const getFeaturedCategories = (storeSlug?: string) => (state: BaseState):
  Category[] => {
  if (state.stores.detail?.slug === storeSlug) {
    return state.featured_categories.list.data;
  }

  return [];
};

export default handleActions<CategoriesState, AbstractPayload>({
  [listFeaturedCategoriesSuccess.toString()]: produce(
    (draft: CategoriesState, { payload }) => {
      draft.list.data = payload;
      draft.list.filter = undefined;
    },
  ),
}, INITIAL_STATE);
